import React, { useEffect, useState, useCallback, useRef } from "react";
import Footer from "../components/footer";
import Header from "../components/header";
import SideNav from "../components/sidenav";
import axios, { Axios } from "axios";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import Loader from "../components/loader";
import CustomEditor from "../../../component/CustomEditor"; // Import the centralized CKEditor component
import CustomTagInput from "../../../component/CustomTagInput";


const AddArtworkDetails = () => {

    let userInfo = JSON.parse(localStorage.getItem('admin-info'));
    const { id } = useParams();
    const editorRef = useRef();
    // State for Checkbox List Subject / Style
    const [subjects, setSubjects] = useState([]);
    const [selectedSubjects, setSelectedSubjects] = useState([]);
    const [styles, setStyles] = useState([]);
    const [selectedStyles, setSelectedStyles] = useState([]);

    const [tags, setTags] = useState([]);

    // State for artworktitle text field
    const [newdata, setNewdata] = useState({
        artworktitle: '', selectedCategory: '0', selectedSeller: '0', selectedArtist: '0',
        selectedMedium: '0', selectedSurface: '0', selectedOriginalart: '1', selectedCertificate: '1',
        eliteChoice: false, newArrival: false, onDemendPrice: false, affordableArt: false,
        artworkprice: '', selectedNegotiable: '1', selectedCommission: '4', selectedRefund: '2',
        selectedCreated: '0', selectedTime: '0', selectedShippedas: '0', selectedPrint: '2',
        artwidth: '', artheight: '', artdepth: '', artweight: '0', selectedSize: '0', selectedOrientation: '0',
        artistremark: '', indiremark: '', description: '', tags: '', image:''
        //selectedSubject: [], // Initialize selectedSubject here
        //selectedStyle: [] // Initialize selectedSubject here
    });

    const [loading, setLoading] = useState(true);

    // State for dropdown

    const [artists, setArtist] = useState([]);
    const [owners, setOwner] = useState([]);
    const [artworks, setArtwork] = useState([]);
    const [mediums, setMedium] = useState([]);
    const [surfaces, setSurface] = useState([]);
    const [commissions, setCommission] = useState([]);
    const [yearCreates, setYearCreated] = useState([]);
    const [shippingTimes, setShippingTime] = useState([]);
    const [packingModes, setPackingMode] = useState([]);
    const [sizes, setSize] = useState([]);
    const [orientations, setOrientation] = useState([]);


    // Function to Fetch data from API for dropdown
    const fetchData = async (url, setData) => {

        try {
            const response = await fetch(url);
            const data = await response.json();
            setLoading(true);
            setData(data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }

    };

    useEffect(() => {

        const fetchDropdowns = async () => {
            fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindOwnerList', setOwner);
            fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindArtistList', setArtist);
            fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-ArtworkList', setArtwork);
            fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-MediumList', setMedium);
            fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-SurfaceList', setSurface);
            fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-CommissionList', setCommission);
            fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-YearCreatedList', setYearCreated);
            fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-ShippingTimeList', setShippingTime);
            fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-PackingModeList', setPackingMode);
            fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-SizeList', setSize);
            fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-OrientationList', setOrientation);
            fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-SubjectList', setSubjects);
            fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-StyleList', setStyles);

            if (id) {
                await fetchArtworkDetails();
                await fetchSubjectsAndStyles();
            }
        };
        fetchDropdowns();
    }, [id]);

    // for Edit Functionality

    const fetchSubjectsAndStyles = async () => {

        try {

            const response1 = await axios.get(`https://igapi.heuristticminds.com/api/SubjectStyleList/Get-GetProductSubjectListByProductID?id=${id}`);
            const dataSubject = response1.data;

            const response2 = await axios.get(`https://igapi.heuristticminds.com/api/SubjectStyleList/Get-GetProductStyleListByProductID?id=${id}`);
            const dataStyle = response2.data;

            const fetchedSubjects = dataSubject || [];
            const fetchedStyles = dataStyle || [];

            const selectedSubjects = fetchedSubjects.map(subjectList => subjectList.id.toString());
            const selectedStyles = fetchedStyles.map(styleList => styleList.id.toString());

            setSelectedSubjects(selectedSubjects);
            setSelectedStyles(selectedStyles);

            setNewdata(prevData => ({
                ...prevData,
                selectedSubject: selectedSubjects,
                selectedStyle: selectedStyles
            }));

        } catch (error) {
            console.error('Error fetching subjects:', error);
        }
    };

    const fetchArtworkDetails = useCallback(async () => {
        if (id) {
            try {

                const response = await axios.get(`https://igapi.heuristticminds.com/api/ProductList/Get-GetArtworkDetailsToEditByProductID?id=${id}`);
                const data = response.data;

                debugger;
                const formattedTags = Array.isArray(data.tags)
                        ? data.tags
                        : (typeof data.tags === "string" && data.tags.trim() !== "")
                        ? data.tags.split(",").map(tag => tag.trim())
                        : [];

                //setTags(formattedTags); // Update tags state separately

                setNewdata(prevData => ({
                    ...prevData,
                    artworktitle: data.productTitle,
                    selectedCategory: data.category_id,
                    selectedSeller: data.owner_id,
                    selectedArtist: data.artist_id,
                    selectedMedium: data.medium_id,
                    selectedSurface: data.surface_id,
                    selectedOriginalart: data.original_painting,
                    selectedCertificate: data.certificate_id,
                    eliteChoice: data.eliteChoice_id,
                    newArrival: data.new_arrival,
                    onDemendPrice: data.price_on_demand,
                    affordableArt: data.affordable_art,
                    artworkprice: data.artist_price,
                    selectedNegotiable: data.negotiable_id,
                    selectedCommission: data.commission_id,
                    selectedRefund: data.refundable_id,
                    selectedCreated: data.created_in?.toString() || '0',
                    selectedTime: data.delevery_time,
                    selectedShippedas: data.packingMode_id,
                    selectedPrint: data.printing_rights,
                    artwidth: data.width,
                    artheight: data.height,
                    artdepth: data.depth,
                    artweight: data.weight,
                    selectedSize: data.size_id,
                    selectedOrientation: data.orientation_id,
                    artistremark: data.remark_to_artist,
                    indiremark: data.remark_to_indigalleria,
                    description: data.description,
                    tags: formattedTags, // Store tags as an array in newdata
                    image: data.image
                    
                }));
            } catch (error) {
                console.error('Error fetching artwork details:', error);
            }
        }
    }, [id]);

    useEffect(() => {

        fetchArtworkDetails();
    }, [fetchArtworkDetails]);

    useEffect(() => {
        console.log("Updated tags in state:", newdata.tags);
    }, [newdata.tags]);

    useEffect(() => {

        fetchSubjectsAndStyles();
    }, [id]);

    // End for Edit Functionality
    const onChangehandle = (e) => {
        e.persist();
        const { name, type, checked, value } = e.target;
    
        setNewdata((prevState) => {
            let updatedData = { ...prevState };
    
            if (type === "checkbox") {
                updatedData[name] = checked;
            } else {
                updatedData[name] = value;
            }
            
              // Determine if we are in edit mode (id exists in URL params)
            const isEditMode = !!id; 
            

            // Handle artist selection logic
            if (name === "selectedArtist" && !isEditMode) {
                updatedData.selectedSeller = value;
            }
    
            return updatedData;
        });
    
        // Reset border styling
        const inputElement = document.getElementsByName(name)[0];
        if (inputElement) {
            inputElement.style.border = "1px solid #dee2e6";
        }
    };
    

   

    const handleEditorChange = (content) => {
        setNewdata(prevState => ({
            ...prevState,
            description: content
        }));
    };
    const [isValid, setIsValid] = useState(true);

    const navigate = useNavigate();
    const handleAddDataClick = async () => {

        if (newdata.artworktitle === '') {
            setIsValid(false);
            const artworktitleInput = document.getElementsByName('artworktitle')[0];
            artworktitleInput.style.border = '1px solid #ff0000';
            artworktitleInput.focus();
            alert('Please Enter Artwork Title.');
        }
        else if (newdata.selectedCategory === 0) {
            setIsValid(false);
            const selectedCategoryInput = document.getElementsByName('selectedCategory')[0];
            selectedCategoryInput.style.border = '1px solid #ff0000';
            selectedCategoryInput.focus();
            alert('Please Select Artwork Category.');
        }
        else if (newdata.selectedSeller === 0) {
            setIsValid(false);
            const selectedSellerInput = document.getElementsByName('selectedSeller')[0];
            selectedSellerInput.style.border = '1px solid #ff0000';
            selectedSellerInput.focus();
            alert('Please Select Seller / Owner.');
        }
        else if (newdata.selectedArtist === 0) {
            setIsValid(false);
            const selectedArtistInput = document.getElementsByName('selectedArtist')[0];
            selectedArtistInput.style.border = '1px solid #ff0000';
            selectedArtistInput.focus();
            alert('Please Select Artist.');
        }
        else if (newdata.selectedMedium === 0) {
            setIsValid(false);
            const selectedMediumInput = document.getElementsByName('selectedMedium')[0];
            selectedMediumInput.style.border = '1px solid #ff0000';
            selectedMediumInput.focus();
            alert('Please Select Medium of Artwork.');
        }
        /* else if (newdata.selectedSurface === 0) {
            setIsValid(false);
            const selectedSurfaceInput = document.getElementsByName('selectedSurface')[0];
            selectedSurfaceInput.style.border = '1px solid #ff0000';
            selectedSurfaceInput.focus(); 
            alert('Please Select Surface of Artwork.');
        } */
        else if (newdata.selectedOriginalart === 0) {
            setIsValid(false);
            const selectedOriginalartInput = document.getElementsByName('selectedOriginalart')[0];
            selectedOriginalartInput.style.border = '1px solid #ff0000';
            selectedOriginalartInput.focus();
            alert('Please Select, If This is Original Artwork or Not.');
        }
        else if (newdata.selectedCertificate === 0) {
            setIsValid(false);
            const selectedCertificateInput = document.getElementsByName('selectedCertificate')[0];
            selectedCertificateInput.style.border = '1px solid #ff0000';
            selectedCertificateInput.focus();
            alert('Please Select, If You Provides Certificate or Not.');
        }
        else if (newdata.artworkprice === '') {
            setIsValid(false);
            const artworkpriceInput = document.getElementsByName('artworkprice')[0];
            artworkpriceInput.style.border = '1px solid #ff0000';
            artworkpriceInput.focus();
            alert('Please Enter Artwork Price.');
        }
        else if (newdata.selectedNegotiable === 0) {
            setIsValid(false);
            const selectedNegotiableInput = document.getElementsByName('selectedNegotiable')[0];
            selectedNegotiableInput.style.border = '1px solid #ff0000';
            selectedNegotiableInput.focus();
            alert('Please Select, If This is Negotiable or Not.');
        }
        else if (newdata.selectedCommission === 0) {
            setIsValid(false);
            const selectedCommissionInput = document.getElementsByName('selectedCommission')[0];
            selectedCommissionInput.style.border = '1px solid #ff0000';
            selectedCommissionInput.focus();
            alert('Please Select, If This is Commissionable or Not.');
        }
        else if (newdata.selectedRefund === 0) {
            setIsValid(false);
            const selectedRefundInput = document.getElementsByName('selectedRefund')[0];
            selectedRefundInput.style.border = '1px solid #ff0000';
            selectedRefundInput.focus();
            alert('Please Select, If This is Refundable or Not.');
        }
        else if (newdata.selectedCreated === 0) {
            setIsValid(false);
            const selectedCreatedInput = document.getElementsByName('selectedCreated')[0];
            selectedCreatedInput.style.border = '1px solid #ff0000';
            selectedCreatedInput.focus();
            alert('Please Select, Creation Year.');
        }
        else if (newdata.selectedTime === 0) {
            setIsValid(false);
            const selectedTimeInput = document.getElementsByName('selectedTime')[0];
            selectedTimeInput.style.border = '1px solid #ff0000';
            selectedTimeInput.focus();
            alert('Please Select Shipping Time.');
        }
        /* else if (newdata.selectedShippedas === 0) {
            setIsValid(false);
            const selectedShippedasInput = document.getElementsByName('selectedShippedas')[0];
            selectedShippedasInput.style.border = '1px solid #ff0000';
            selectedShippedasInput.focus();
            alert('Please Select Packing Style.');
        } */
        else if (newdata.selectedPrint === 0) {
            setIsValid(false);
            const selectedPrintInput = document.getElementsByName('selectedPrint')[0];
            selectedPrintInput.style.border = '1px solid #ff0000';
            selectedPrintInput.focus();
            alert('Please Select If Print Available or Not.');
        }
        else if (newdata.artwidth === '') {
            setIsValid(false);
            const artwidthInput = document.getElementsByName('artwidth')[0];
            artwidthInput.style.border = '1px solid #ff0000';
            artwidthInput.focus();
            alert('Please Enter Width of Artwork.');
        }
        else if (newdata.artheight === '') {
            setIsValid(false);
            const artheightInput = document.getElementsByName('artheight')[0];
            artheightInput.style.border = '1px solid #ff0000';
            artheightInput.focus();
            alert('Please Enter Height of Artwork.');
        }
        else if (newdata.selectedSize === 0) {
            setIsValid(false);
            const selectedSizeInput = document.getElementsByName('selectedSize')[0];
            selectedSizeInput.style.border = '1px solid #ff0000';
            selectedSizeInput.focus();
            alert('Please Select Size.');
        }
        /* else if (newdata.selectedOrientation === 0) {
            setIsValid(false);
            const selectedOrientationInput = document.getElementsByName('selectedOrientation')[0];
            selectedOrientationInput.style.border = '1px solid #ff0000';
            selectedOrientationInput.focus();
            alert('Please Select Orientation.');
        } */
        else if (newdata.description === '') {
            setIsValid(false);
            const descriptionInput = document.getElementsByName('description')[0];
            descriptionInput.style.border = '1px solid #ff0000';
            descriptionInput.focus();
            alert('Please Enter Short Description about the Artwork.');
        }

        else {
            setIsValid(true);

            // Helper function to handle empty values
            const handleEmptyValue = (value, isFloat = false) => {
                if (value === '') return isFloat ? 0.00 : 0;
                return isFloat ? parseFloat(value).toFixed(2) : parseInt(value, 10);
            };

            const tagsString = Array.isArray(newdata.tags) ? newdata.tags.join(",") : newdata.tags

            let postData = {
                "productTitle": newdata.artworktitle,
                "category_id": parseInt(newdata.selectedCategory, 10),
                "owner_id": parseInt(newdata.selectedSeller, 10),
                "artist_id": parseInt(newdata.selectedArtist, 10),

                "medium_id": parseInt(newdata.selectedMedium, 10),
                "surface_id": parseInt(newdata.selectedSurface, 10),
                "original_painting": parseInt(newdata.selectedOriginalart, 10),
                "certificate_id": parseInt(newdata.selectedCertificate, 10),


                "eliteChoice_id": newdata.eliteChoice ? 1 : 0,
                "new_arrival": newdata.newArrival ? 1 : 0,
                "price_on_demand": newdata.onDemendPrice ? 1 : 0,
                "affordable_art": newdata.affordableArt ? 1 : 0,

                "artist_price": parseInt(newdata.artworkprice, 10),
                "negotiable_id": parseInt(newdata.selectedNegotiable, 10),
                "commission_id": parseInt(newdata.selectedCommission, 10),
                "refundable_id": parseInt(newdata.selectedRefund, 10),

                "created_in": newdata.selectedCreated,
                "delevery_time": parseInt(newdata.selectedTime, 10),
                "packingMode_id": parseInt(newdata.selectedShippedas, 10),
                "printing_rights": parseInt(newdata.selectedPrint, 10),

                "width": handleEmptyValue(newdata.artwidth, true),
                "height": handleEmptyValue(newdata.artheight, true),
                "depth": handleEmptyValue(newdata.artdepth, true),
                "weight": handleEmptyValue(newdata.artweight, true),
                "size_id": parseInt(newdata.selectedSize, 10),
                "orientation_id": parseInt(newdata.selectedOrientation, 10),

                "remark_to_artist": newdata.artistremark,
                "remark_to_indigalleria": newdata.indiremark,
                "description": newdata.description,
                "tags": tagsString,
                "createdBy": userInfo.user_id,
                "id": id
                
            }
            try {
                let response;
                if (id) {
                    // Edit mode: Update existing artwork
                    postData = { ...postData, id };
                    response = await fetch('https://igapi.heuristticminds.com/api/ProductList/Update-UpdateProductDetails', {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(postData),
                    });
                } else {
                    // Add mode: Insert new artwork
                    response = await fetch('https://igapi.heuristticminds.com/api/ProductList/Add-SaveProductDetails', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(postData),
                    });
                }
                if (response.ok) {

                    const contentType = response.headers.get('content-type');
                    let responseData;

                    if (contentType && contentType.indexOf('application/json') !== -1) {
                        // Parse the JSON response
                        responseData = await response.json();
                    } else {
                        // Parse the text response
                        const responseText = await response.text();
                        responseData = { message: responseText };
                    }
                    let productId = '';
                    if (id) {
                        productId = id;
                    }
                    else {
                        productId = responseData.newlyCreatedProductID; // Assuming your API returns productId upon successful creation
                    }
                    // Debug logs
                    console.log('subjects:', subjects);
                    console.log('newdata.selectedSubject:', newdata.selectedSubject);

                    // Filter out selected subjects and Style
                    const selectedSubjects = subjects.filter(subjectList => newdata.selectedSubject.includes(String(subjectList.id)));
                    const selectedStyles = styles.filter(styleList => newdata.selectedStyle.includes(String(styleList.id)));

                    // Debug logs
                    console.log('selectedSubjects:', selectedSubjects);
                    console.log('selectedStyles:', selectedStyles);

                    // Iterate over selected subjects and save them
                    const subjectSavePromises = selectedSubjects.map(async (subject) => {
                        const subjectData = {
                            product_id: productId, // Use productId received from the API response
                            subject_id: subject.id // Assuming subject object has an id property
                        };

                        // Make API call to save subject
                        const subjectResponse = await axios.post('https://igapi.heuristticminds.com/api/SubjectStyleList/Add-SaveProductSubjectList', subjectData);
                        return subjectResponse;
                    });

                    // Wait for all subject saves to complete
                    await Promise.all(subjectSavePromises);
                    // Iterate over selected subjects and save them
                    const styleSavePromises = selectedStyles.map(async (style) => {
                        const styleData = {
                            product_id: productId, // Use productId received from the API response
                            style_id: style.id // Assuming subject object has an id property
                        };

                        // Make API call to save subject
                        const styleResponse = await axios.post('https://igapi.heuristticminds.com/api/SubjectStyleList/Add-SaveProductStyleList', styleData);
                        return styleResponse;
                    });

                    // Wait for all subject saves to complete
                    await Promise.all(styleSavePromises);

                    if (id) {
                        alert('Artwork and Subjects/Styles Updated Successfully!');
                    } else {
                        alert('Artwork and Subjects/Styles Added Successfully!');
                    }

                    navigate('/artworkAll');


                } else {
                    console.log('Failed to update data');
                }
            } catch (error) {
                console.error('Error updating data:', error);
                console.log('Error updating data');
            }
        }
    }
    const handleSubjectChange = (event) => {
        const value = event.target.value;
        const updatedSelectedSubjects = selectedSubjects.includes(value)
            ? selectedSubjects.filter(subject => subject !== value)
            : [...selectedSubjects, value];

        setSelectedSubjects(updatedSelectedSubjects);
        setNewdata(prevState => ({ ...prevState, selectedSubject: updatedSelectedSubjects }));

    };

    const handleStyleChange = (event) => {
        const value = event.target.value;
        const updatedSelectedStyles = selectedStyles.includes(value)
            ? selectedStyles.filter(style => style !== value)
            : [...selectedStyles, value];

        setSelectedStyles(updatedSelectedStyles);
        setNewdata(prevState => ({ ...prevState, selectedStyle: updatedSelectedStyles }));
    };

    const handleTagsChange = (updatedTagsString) => {
        setNewdata((prevData) => ({
            ...prevData,
            tags: updatedTagsString,  // Save tags as a comma-separated string
        }));
    };

    return (
        <>
            {loading ? <Loader /> : ''}
            <Header />
            <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">
                    <div>
                        <div className="page-header">
                            <div className="container-xl px-4">
                                <div className="page-header-title">
                                    <div className="page-header-icon">
                                        <i className="bi bi-images"></i>
                                    </div>
                                    {id > 0 ? "Edit Artwork" : "Add New Artwork"}
                                </div>
                            </div>
                        </div>
                        <div className="container-xl px-4">
                            <div className="row">
                                <div className="col-lg-12 mb-4">
                                    <div className="card mb-4 h-100">
                                        <div className="card-header">Details of Artwork</div>
                                        <div className="card-body">
                                            <NavLink className="btn btn-primary float-end" to={'/artworkAll'}  onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}><i className="bi bi-arrow-return-left"></i> Back</NavLink>
                                            <div className="p-4">
                                                <div className="row">
                                                    <div className="col-sm-6 ps-0">
                                                        <div className="col-sm-8 form-group mb-3">
                                                            <label>Artwork Title<span style={{ color: "#ff0000" }}>*</span></label>
                                                            <input type="text" value={newdata.artworktitle} onChange={onChangehandle} name="artworktitle" className="form-control" placeholder="Artwork Title" />
                                                        </div>
                                                        <div className="col-sm-8 form-group mb-3">
                                                            <label>Artwork Category<span style={{ color: "#ff0000" }}>*</span></label>
                                                            <select value={newdata.selectedCategory} onChange={onChangehandle} name="selectedCategory" className="form-control form-select">
                                                                <option value="0">-- Select --</option>
                                                                {artworks.map((artwork) => (
                                                                    <option key={artwork.id} value={artwork.id}>
                                                                        {artwork.artwork}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div className="col-sm-8 form-group mb-3">
                                                            <label>Artist </label>
                                                            <select value={newdata.selectedArtist} onChange={onChangehandle} name="selectedArtist" className="form-control form-select">
                                                                <option value="0">-- Select --</option>
                                                                {
                                                                    artists.map((artist) => (
                                                                        <option key={artist.id} value={artist.id}>
                                                                            {artist.artist}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                        </div>
                                                        <div className="col-sm-8 form-group mb-3">
                                                            <label>Seller (Ownership)</label>
                                                            <select value={newdata.selectedSeller} onChange={onChangehandle} name="selectedSeller" className="form-control form-select">
                                                                <option value="0">-- Select --</option>
                                                                {
                                                                    owners.map((ownerList) => (
                                                                        <option key={ownerList.id} value={ownerList.id}>
                                                                            {ownerList.owner}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                        </div>
                                                        
                                                    </div>
                                                    <div className="col-sm-5">
                                                        <div className="imgpreview">
                                                        {id ? (
                                                                <a href={`/uploadArtwork/${id}`}>
                                                                     <img src={`../images/products/thumbnail/${newdata.image}`} alt="" style={{ cursor: "pointer" }}/>
                                                                </a>
                                                            ) : (
                                                                    <img src="../images/bg2.png" alt="" style={{ cursor: "not-allowed", opacity: 0.5 }} />
                                                        )}
                                                        </div>
                                                    </div>

                                                </div>

                                                <div className="row">

                                                    <div className="col-sm-3 form-group mb-3">
                                                        <label>Medium<span style={{ color: "#ff0000" }}>*</span></label>
                                                        <select value={newdata.selectedMedium} onChange={onChangehandle} name="selectedMedium" className="form-control form-select">
                                                            <option value="0">-- Select --</option>
                                                            {mediums.map((medium) => (
                                                                <option key={medium.id} value={medium.id}>
                                                                    {medium.medium}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-sm-3 form-group mb-3">
                                                        <label>Surface<span style={{ color: "#ff0000" }}>*</span></label>
                                                        <select value={newdata.selectedSurface} onChange={onChangehandle} name="selectedSurface" className="form-control form-select">
                                                            <option value="0">-- Select --</option>
                                                            {surfaces.map((surface) => (
                                                                <option key={surface.id} value={surface.id}>
                                                                    {surface.surface}</option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    <div className="col-sm-3 form-group mb-3">
                                                        <label>Is this original artwork?</label>
                                                        <select value={newdata.selectedOriginalart} onChange={onChangehandle} name="selectedOriginalart" className="form-control form-select">
                                                            <option value="0">-- Select --</option>
                                                            <option value="1">Yes</option>
                                                            <option value="2">No</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-sm-3 form-group mb-3">
                                                        <label>Do you provide the artist certificate?</label>
                                                        <select value={newdata.selectedCertificate} onChange={onChangehandle} name="selectedCertificate" className="form-control form-select">
                                                            <option value="0">-- Select --</option>
                                                            <option value="1">Yes</option>
                                                            <option value="2">No</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="row p-3">
                                                    <div className="col-sm-12">
                                                        <div className="form-check form-check-inline me-5">
                                                            <input type="checkbox" id="eliteChoice" name="eliteChoice" className="form-check-input" onChange={onChangehandle} checked={newdata.eliteChoice}></input>
                                                            <label for="eliteChoice" className="form-check-label">Curator's Choice</label>
                                                        </div>
                                                        <div className="form-check form-check-inline me-5">
                                                            <input type="checkbox" id="newArrival" name="newArrival" className="form-check-input" onChange={onChangehandle} checked={newdata.newArrival}></input>
                                                            <label for="newArrival" className="form-check-label">New Arrival</label>
                                                        </div>
                                                        <div className="form-check form-check-inline me-5">
                                                            <input type="checkbox" id="onDemendPrice" name="onDemendPrice" className="form-check-input" onChange={onChangehandle} checked={newdata.onDemendPrice}></input>
                                                            <label for="onDemendPrice" className="form-check-label" >Price On Demand</label>
                                                        </div>
                                                        <div className="form-check form-check-inline me-5">
                                                            <input type="checkbox" id="affordableArt" name="affordableArt" className="form-check-input" onChange={onChangehandle} checked={newdata.affordableArt}></input>
                                                            <label for="affordableArt" className="form-check-label" >Affordable Art</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-3 form-group mb-3">
                                                        <label>Artwork Price<span style={{ color: "#ff0000" }}>*</span></label>
                                                        <input type="text" placeholder="Artwork price" className="form-control" value={newdata.artworkprice} onChange={onChangehandle} name="artworkprice" />
                                                    </div>
                                                    <div className="col-sm-3 form-group mb-3">
                                                        <label>Is it negotiable?</label>
                                                        <select value={newdata.selectedNegotiable} onChange={onChangehandle} name="selectedNegotiable" className="form-control form-select">
                                                            <option value="0">-- Select --</option>
                                                            <option value="1">Yes</option>
                                                            <option value="2">No</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-sm-3 form-group mb-3">
                                                        <label>Is it commissionable?</label>
                                                        <select value={newdata.selectedCommission} onChange={onChangehandle} name="selectedCommission" className="form-control form-select">
                                                            <option value="0">-- Select --</option>
                                                            {commissions.map((commission) => (
                                                                <option key={commission.id} value={commission.id}>
                                                                    {commission.commission}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-sm-3 form-group mb-3">
                                                        <label>Is it refundable?</label>
                                                        <select value={newdata.selectedRefund} onChange={onChangehandle} name="selectedRefund" className="form-control form-select">
                                                            <option value="0">-- Select --</option>
                                                            <option value="1">Yes</option>
                                                            <option value="2">No</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-sm-3 form-group mb-3">
                                                        <label>Select Year Created</label>
                                                        <select value={newdata.selectedCreated} onChange={onChangehandle} name="selectedCreated" className="form-control form-select">
                                                            <option value="0">-- Select --</option>
                                                            {yearCreates.map((year) => (
                                                                <option key={year.yearCreated} value={year.yearCreated}>
                                                                    {year.yearCreated}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-sm-3 form-group mb-3">
                                                        <label>Shipping time<span style={{ color: "#ff0000" }}>*</span></label>
                                                        <select value={newdata.selectedTime} onChange={onChangehandle} name="selectedTime" className="form-control form-select">
                                                            <option value="0">-- Select --</option>
                                                            {shippingTimes.map((shipping) => (
                                                                <option key={shipping.id} value={shipping.id}>
                                                                    {shipping.shippingTime}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-sm-3 form-group mb-3">
                                                        <label>To be shipped as</label>
                                                        <select value={newdata.selectedShippedas} onChange={onChangehandle} name="selectedShippedas" className="form-control form-select">
                                                            <option value="0">-- Select --</option>
                                                            {packingModes.map((packing) => (
                                                                <option key={packing.id} value={packing.id}>
                                                                    {packing.packingMode}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-sm-3 form-group mb-3">
                                                        <label>Print Available?</label>
                                                        <select value={newdata.selectedPrint} onChange={onChangehandle} name="selectedPrint" className="form-control form-select">
                                                            <option value="0">-- Select --</option>
                                                            <option value="1">Yes</option>
                                                            <option value="2">No</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <strong>Dimentions</strong>
                                                    <div className="col-sm-5 mb-3">
                                                        <div className="d-inline-flex bg-light border p-3">
                                                            <div className="form-group pe-3">
                                                                <small>Width (In inches)<span style={{ color: "#ff0000" }}>*</span></small>
                                                                <input type="text" placeholder="Width" className="form-control" value={newdata.artwidth} onChange={onChangehandle} name="artwidth" />
                                                            </div>
                                                            <div className="form-group pe-3">
                                                                <small>Height (In inches)<span style={{ color: "#ff0000" }}>*</span></small>
                                                                <input type="text" placeholder="Height" className="form-control" value={newdata.artheight} onChange={onChangehandle} name="artheight" />
                                                            </div>
                                                            <div className="form-group ">
                                                                <small>Depth (In inches)<span style={{ color: "#ff0000" }}>*</span></small>
                                                                <input type="text" placeholder="Depth" className="form-control" value={newdata.artdepth} onChange={onChangehandle} name="artdepth" disabled={newdata.selectedCategory !== "134"} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-7 mb-3">
                                                        <div className="d-flex bg-light border p-3">
                                                            <div className="form-group col pe-3">
                                                                <small>Weight (In Grams)</small>
                                                                <input type="text" placeholder="Weight" className="form-control" value={newdata.artweight} onChange={onChangehandle} name="artweight" disabled={newdata.selectedCategory !== "134"}  />
                                                            </div>
                                                            <div className="form-group col pe-3">
                                                                <small>Size<span style={{ color: "#ff0000" }}>*</span></small>
                                                                <select value={newdata.selectedSize} onChange={onChangehandle} name="selectedSize" className="form-control form-select">
                                                                    <option value="0">-- Select --</option>
                                                                    {sizes.map((size) => (
                                                                        <option key={size.id} value={size.id}>
                                                                            {size.size}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            <div className="form-group col">
                                                                <small>Orientation<span style={{ color: "#ff0000" }}></span></small>
                                                                <select value={newdata.selectedOrientation} onChange={onChangehandle} name="selectedOrientation" className="form-control form-select" disabled={newdata.selectedCategory == "134"} >
                                                                    <option value="0">-- Select --</option>
                                                                    {orientations.map((orientation) => (
                                                                        <option key={orientation.id} value={orientation.id}>
                                                                            {orientation.orientation}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-12 form-group mb-3">
                                                        <label>Artist remark for IndiGalleria</label>
                                                        <input type="text" placeholder="Artist remark" className="form-control" value={newdata.artistremark} onChange={onChangehandle} name="artistremark" />
                                                    </div>
                                                    <div className="col-sm-12 form-group mb-3">
                                                        <label>Indigalleria remark for Artist</label>
                                                        <input type="text" placeholder="Indigalleria remark" className="form-control" value={newdata.indiremark} onChange={onChangehandle} name="indiremark" />
                                                    </div>
                                                    <div className="col-sm-12 form-group mb-3">
                                                        <label>Short description about the artwork (will be displayed online)*</label>
                                                        <CustomEditor
                                                            ref={editorRef}
                                                            value={newdata.description}                                                             
                                                            onChange={handleEditorChange}
                                                        />
                                                        
                                                    </div>

                                                    <div className="col-sm-12 form-group mb-3">
                                                        <label>Choose Subject</label>
                                                        <div className="row p-3">
                                                            {subjects.map((subjectList) => (
                                                                <div className="form-check col-sm-3 mb-2" key={subjectList.id}>
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        value={subjectList.id.toString()}
                                                                        id={subjectList.id}
                                                                        checked={selectedSubjects.includes(subjectList.id.toString())}
                                                                        onChange={handleSubjectChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor={subjectList.id}>{subjectList.subject}</label>
                                                                </div>
                                                            ))}

                                                        </div>
                                                        <hr />
                                                    </div>
                                                    <div className="col-sm-12 form-group mb-3">
                                                        <label>Choose Style</label>

                                                        <div className="row p-3">
                                                            {styles.map((styleList) => (
                                                                <div className="form-check col-sm-3 mb-2" key={styleList.id}>
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        value={styleList.id.toString()}
                                                                        id={styleList.id}
                                                                        checked={selectedStyles.includes(styleList.id.toString())}
                                                                        onChange={handleStyleChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor={styleList.id}>{styleList.style}</label>
                                                                </div>
                                                            ))}

                                                        </div>
                                                    </div>
                                                    <div className="col-sm-12 form-group mb-3">
                                                        <label>Tags</label>  
                                                        <CustomTagInput 
                                                            initialTags={Array.isArray(newdata.tags) ? newdata.tags : []}  
                                                            onTagsChange={(updatedTags) => 
                                                            setNewdata(prevData => ({ ...prevData, tags: updatedTags }))
                                                            }
                                                        />                                          
                                                    </div>
                                                    <div className="col-sm-6 form-group">
                                                        <button onClick={handleAddDataClick} className="btn btn-primary w-50">Submit</button>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>


        </>
    )
}

export default AddArtworkDetails;